import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const TabSelectionWrapper = styled('div')`
  position: relative;
  width: 100%;
  height: ${({ theme }) => theme.x5spacePx}px;
`;

interface Props {
  width?: number;
}

export const TabRow = styled('div')<Props>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }
`;

export const TabWrapper = styled('div')`
  position: relative;
`;

interface TabButtonProps {
  selected?: boolean;
}

export const TabButton = styled('button')<TabButtonProps>`
  margin: 4px;
  width: ${({ theme }) => theme.x15spacePx}px;
  height: ${({ theme }) => theme.x4spacePx}px;
  ${({ selected, theme }) =>
    selected && `background: ${theme.color.brand02RGBA(0.1)};`}
  color: ${({ selected, theme }) =>
    selected ? theme.color.brand01 : theme.color.whiteRGBA(0.5)};
  border-radius: 4px;
  ${({ theme }) => theme.typography.xSmall};

  &:hover {
    background-color: ${({ selected, theme }) =>
      !selected && theme.color.whiteRGBA(0.05)};
  }

  ${media.smDown`
    width: ${({ theme }) => theme.x10spacePx}px;
  `}
`;

interface TabOverflowProps {
  side: 'left' | 'right';
}

export const TabOverflowEdges = styled('div')<TabOverflowProps>`
  position: absolute;
  pointer-events: none;
  top: 0;
  bottom: 0;
  ${({ side }) => `${side}: 0`};
  width: 20px;
  height: 100%;
`;

export const TabOverflowShadow = styled('div')<TabOverflowProps>`
  position: absolute;
  pointer-events: none;
  width: 36px;
  top: 0;
  bottom: 0;
  ${({ side }) => `${side}: 0`};

  background: ${({ side, theme }) =>
    `linear-gradient(${
      side === 'left' ? -90 : 90
    }deg, rgba(21, 27, 36, 0) 0%, ${theme.color.charcoal} 100%);`};
`;
